// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StickerPackList__container-f4bd4e {
  height: 48px;
  display: flex;
  align-items: center;
}

.StickerPackList__settings-ae435f {
  margin: 0 6px 4px;
}

.StickerPackList__horizontal-scroll-cedc44 {
  flex: 1;
  display: flex;
  align-items: center;
  height: 48px;
  overflow-x: scroll;
  overflow-y: hidden;
  padding: 0 9px;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/ChatFooter/InputPanel/InputSection/EmojisStickersButton/EmojiStickersPanel/StickerPanel/StickerPackList/StickerPackList.styles.m.css"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;;AAEA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AACF","sourcesContent":[".container {\n  height: 48px;\n  display: flex;\n  align-items: center;\n}\n\n.settings {\n  margin: 0 6px 4px;\n}\n\n.horizontal-scroll {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  height: 48px;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  padding: 0 9px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `StickerPackList__container-f4bd4e`,
	"settings": `StickerPackList__settings-ae435f`,
	"horizontal-scroll": `StickerPackList__horizontal-scroll-cedc44`,
	"horizontalScroll": `StickerPackList__horizontal-scroll-cedc44`
};
module.exports = ___CSS_LOADER_EXPORT___;
